<div class="container">
  <div class="label-container">
    @let offer = challenge();
    @if (offer.type === OfferType.FREQUENCY) {
      <p
        class="minimum-spend-label"
        [style.color]="config().minimumSpendLabel.color"
        [style.fontFamily]="config().minimumSpendLabel.fontFamily"
        [innerHTML]="
          config().minimumSpendLabel.text
            | replaceVars: offer.minAmountByTransaction
            | safe
        "
      ></p>
    }

    <p
      class="offer-label"
      [style.color]="config().offerLabel.color"
      [style.fontFamily]="config().offerLabel.fontFamily"
      [innerHTML]="
        config().offerLabel.text
          | replaceVars: (maxReward() | formatReward)
          | safe
      "
    ></p>
  </div>
  <div class="button-container">
    <b2c-button
      [styles]="{
        fontSize: '14px',
        width: '250px',
        padding: '0.5rem 1rem',
        border: 'none',
        color: config().button.color,
        fontFamily: config().button.fontFamily,
        backgroundColor: config().button.backgroundColor,
      }"
      data-cy="select_btn"
      [title]="config().button.title"
      [loading]="selectionInProgress()"
      [attr.aria-label]="config().button.title"
      (click)="
        selectChallenge(
          challenge(),
          phase(),
          isBisCampaign(),
          isEventChallenge()
        )
      "
      [disabled]="
        challenge().isOutOfStock() ||
        selectionInProgress() ||
        blockSelectionButton()
      "
    >
      {{ config().button.label }}
    </b2c-button>
  </div>
</div>
